import React from 'react';

export default ({
  calculatePositionOfStickyHeaders,
  config,
  index,
  targetRole,
}) => (
  <td
    className={`role-cell text-right ${index === 0 ? 'first-cell' : ''}`}
    style={{
      ...calculatePositionOfStickyHeaders(config),
      verticalAlign: 'middle',
    }}
  >
    {targetRole && (
      <span className={`role-${targetRole.title}`}>
        {targetRole.title.capitalize()}
      </span>
    )}
  </td>
);
